module.exports = __webpack_public_path__ + "static/media/envelope-mail-email-svgrepo-com.e0ff3eb6.svg";